<template>
    <div id="org_settings_team">
        
        <!-- Agency Table Card -->
        <div class="card mb-3 table-card" v-if="filtered_agency_list.length > 0">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <h3 class="mt-2">Partners ({{ filtered_agency_list.length }})</h3>
                    </div>
                    <div class="col-lg-6 d-none d-lg-block">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input type="text" class="search-box form-control me-1 py-2" placeholder="Search Partners..." aria-label="Search Partners..." v-model="agency_search_key" @input="searchAgency()" autocomplete="one-time-code">
                                <i class="fa fa-search search-placeholder-icon" v-if="!agency_search_key"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                    <th @click.prevent="sortAgencyByKey('name')" class="d-table-cell">
                                        <div class="d-flex flex-row">
                                            Partner Name
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': agency_sort_key === 'name' && agency_sort_order === 'asc'}" alt="">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': agency_sort_key === 'name' && agency_sort_order === 'des'}" alt="">
                                            </div>
                                        </div>
                                    </th>
                                    <th class="d-none d-md-table-cell">
                                        <div class="d-flex flex-row" @click.prevent="sortAgencyByKey('access')">
                                            Access Level
                                            <div class="d-flex flex-column">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': agency_sort_key === 'access' && agency_sort_order === 'asc'}" alt="">
                                                <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': agency_sort_key === 'access' && agency_sort_order === 'des'}" alt="">
                                            </div>
                                        </div>
                                    </th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1" v-if="canEdit('settings')">
                                    <div class="d-flex flex-row">
                                        Action
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(agency, index) in agency_list_shown" :key="agency.id">
                                <td class="d-table-cell">
                                    <img 
                                        class="avatar rounded-circle me-3" 
                                        :src="agency.logo" 
                                        alt="Agency Logo"
                                    />
                                    {{ agency.name }}
                                </td>
                                <td class="d-none d-md-table-cell">
                                    <span class="badge" :class="getAccessBadgeClass(agency.pivot.access)">
                                        {{ getAccessLevel(agency.pivot.access) }}
                                    </span>
                                </td>
                                <td class="table-column-action d-table-cell">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button v-if="canEdit('settings')" class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false"  aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" alt="" />
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a class="dropdown-item" :href="`/settings/${client.url}/agency_permission/${agency.id}`">
                                                <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt="">Edit Partner
                                            </a>
                                            <hr class="my-1" v-if="!agencyHasActiveSubscriptions(agency)"/>
                                            <a 
                                                class="dropdown-item text-danger" 
                                                v-if="!agencyHasActiveSubscriptions(agency)"
                                                href="#" 
                                                @click.prevent="deleteAgency(agency, index)"
                                            >
                                                <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt="">Remove Partner
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" name="agency_num_per_page" id="agency_num_per_page" v-model="agency_num_per_page" @change="reloadAgencyPagination(filtered_agency_list)" aria-label="Agency Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in agency_num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ agency_num_per_page === '5000' ? 'ALL' : agency_num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_agency_list.length === 0 ? '0' : agency_item_interval }} of {{ filtered_agency_list.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="agency_page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click.prevent="moveToPrevAgencyPage(filtered_agency_list)" :disabled="agency_page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="agency_page_index_array.length <= 3">
                                                <button v-for="page in agency_page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="{'current-page': page === agency_page_index + 1}" @click.prevent="moveToAgencyPage(page, filtered_agency_list)">
                                                    {{page}}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-if="agency_page_index_array.length > 3">
                                                <button v-for="page in agency_page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="{'current-page': page === agency_page_index + 1}" @click.prevent="moveToAgencyPage(page, filtered_agency_list)">
                                                    {{page}}
                                                </button>

                                                <button v-if="agency_page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                    ...
                                                </button>
                                                <button v-if="agency_page_index >= 2 && agency_page_index < agency_page_index_array.length - 1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{agency_page_index + 1}}
                                                </button>

                                                <button v-if="agency_page_index < agency_page_index_array.length - 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                    ...
                                                </button>
                                                <button :class="{'current-page': agency_page_index === agency_page_index_array.length - 1}" class="btn btn-none btn-icon-only-md" @click.prevent="moveToAgencyPage(agency_page_index_array.length, filtered_agency_list)" :key="agency_page_index_array.length">
                                                    {{ agency_page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="agency_page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click.prevent="moveToNextAgencyPage(filtered_agency_list)" :disabled="agency_page_index === agency_page_count - 1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>

        <div class="card mb-3 table-card">
            <div class="card-header">
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <h3 class="mt-2">Team Members ({{ filtered_user_list.length }})</h3>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="d-flex justify-content-end justify-self-end gap-2">
                            <div class="position-relative">
                                <input type="text" class="search-box form-control me-1 py-2" placeholder="Search by Name..." aria-label="Search by Name..." v-model="search_key" @input="searchUser()" autocomplete="one-time-code">
                                <i class="fa fa-search search-placeholder-icon" v-if="!search_key"></i>
                            </div>

                            <div v-if="!canEdit('settings')" data-bs-toggle="tooltip" title="You do not have privileges to complete this action">
                                <button class="btn btn-primary float-end" :disabled="true">
                                    <i class="fas fa-fw fa-plus"></i> Add Team Member
                                </button>
                            </div>
                            <a v-else class="btn btn-primary float-end" :href="`/settings/${client.url}/user_permission/new`">
                                <span>
                                    <i class="fas fa-fw fa-plus"></i> Add Team Member
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="table-width-responsive">
                    <table class="table table-with-pagination mb-0">
                        <thead>
                            <tr class="table-header-row">
                                <th @click.prevent="sortByKey('name')" class="d-table-cell">
                                    <div class="d-flex flex-row">
                                        Name
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'name' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'name' && sort_order === 'des'}" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th v-if="if_show_org_column" @click.prevent="sortByKey('organization')" class="d-none d-sm-table-cell">
                                    <div class="d-flex flex-row">
                                        Organization
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'organization' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'organization' && sort_order === 'des'}" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click.prevent="sortByKey('email')" class="d-none d-lg-table-cell">
                                    <div class="d-flex flex-row">
                                        Email
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'email' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'email' && sort_order === 'des'}" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th @click.prevent="sortByKey('access')" class="d-none d-md-table-cell">
                                    <div class="d-flex flex-row">
                                        Access Level
                                        <div class="d-flex flex-column">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-up.svg" :class="{'sort-key-active': sort_key === 'access' && sort_order === 'asc'}" alt="">
                                            <img class="sort-key" src="/img/icons/avid-icons/chevron-down.svg" :class="{'sort-key-active': sort_key === 'access' && sort_order === 'des'}" alt="">
                                        </div>
                                    </div>
                                </th>
                                <th class="d-none d-md-table-cell column-sort-disabled">
                                    2FA Enabled
                                </th>
                                <th class="d-table-cell column-sort-disabled pe-3" width="1" v-if="canEdit('settings')">
                                    <div class="d-flex flex-row">
                                        Action
                                    </div>
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(u, index) in list_shown" :key="u.id">
                                <td class="d-table-cell">
                                    {{ u.name }}
                                </td>
                                <td v-if="if_show_org_column" class="d-none d-sm-table-cell">
                                    {{ u.organization }}
                                </td>
                                <td class="d-none d-lg-table-cell">
                                    {{ u.email }}
                                </td>
                                <td class="d-none d-md-table-cell">
                                    <span class="badge" :class="getAccessBadgeClass(u.pivot.access)">
                                        {{ getAccessLevel(u.pivot.access) }}
                                    </span>
                                </td>
                                <td class="d-none d-md-table-cell text-center" :class="{'text-success': u.two_factor_enabled }">
                                    <img v-if="u.two_factor_enabled" src="/img/icons/avid-icons/check-circle.svg" class="icon" alt="2FA enabled" style="width: 20px; height: 20px;">
                                    <span v-else class="text-muted">—</span>
                                </td>

                                <td class="table-column-action d-table-cell">
                                    <div class="dropdown d-flex justify-content-center">
                                        <button v-if="canEdit('settings')" class="btn btn-white btn-icon-only-md" data-bs-toggle="dropdown" data-bs-auto-close="true" aria-expanded="false"  aria-label="Button">
                                            <img class="icon" src="/img/icons/avid-icons/dots-vertical.svg" alt="" />
                                        </button>
                                        <div class="dropdown-menu dropdown-menu-primary dropdown-menu-end">
                                            <a class="dropdown-item" :href="`/settings/${client.url}/user_permission/${u.url}`">
                                                <img class="icon me-2" src="/img/icons/avid-icons/edit.svg" alt="">Edit
                                            </a>
                                            <a v-if="user.user_type === 'admin' && u.two_factor_enabled" class="dropdown-item" href="#" @click.prevent="disableUserTwoFactor(u, index)">
                                                <img class="icon me-2" src="/img/icons/avid-icons/strongbox-2.svg" alt="">Disable 2FA
                                            </a>
                                            <hr class="my-1"/>
                                            <a class="dropdown-item text-danger" href="#" @click.prevent="deleteTeamUser(u, index)">
                                                <img class="icon red-icon me-2" src="/img/icons/avid-icons/trash.svg" alt="">Remove
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="table-border-bottom-0">
                            <tr>
                                <td colspan="100%" class="py-0">
                                    <div class="table-pagination">
                                        <div class="table-pagination--group d-none d-md-flex">
                                            <div class="position-relative">
                                                <select class="form-select" name="num_per_page" id="num_per_page" v-model="num_per_page" @change="reloadPagination(filtered_user_list)" aria-label="Num Per Page">
                                                    <option value="5000">ALL</option>
                                                    <option v-for="num in num_per_page_options" :key="num" :value="num">{{ num }}</option>
                                                </select>
                                                <div class="select-display-text">
                                                    Showing {{ num_per_page === '5000' ? 'ALL' : num_per_page }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="table-pagination--group d-none d-lg-flex">
                                            {{ filtered_user_list.length === 0 ? '0' : item_interval }} of {{ filtered_user_list.length }}
                                        </div>

                                        <div class="table-pagination--group">
                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md me-1" @click.prevent="moveToPrevPage(filtered_user_list)" :disabled="page_index === 0" data-bs-toggle="tooltip" title="Previous page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-left.svg" alt="">
                                            </button>

                                            <div class="d-flex page-selector" v-if="page_index_array.length <= 3">
                                                <button v-for="page in page_index_array" :key="page" class="btn btn-none btn-icon-only-md" :class="{'current-page': page === page_index + 1}" @click.prevent="moveToPage(page, filtered_user_list)">
                                                    {{page}}
                                                </button>
                                            </div>
                                            <div class="d-flex page-selector" v-if="page_index_array.length > 3">
                                                <button v-for="page in page_index_array.slice(0,2)" :key="page" class="btn btn-none btn-icon-only-md" :class="{'current-page': page === page_index + 1}" @click.prevent="moveToPage(page, filtered_user_list)">
                                                    {{page}}
                                                </button>

                                                <button v-if="page_index > 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled>
                                                    ...
                                                </button>
                                                <button v-if="page_index >= 2 && page_index < page_index_array.length - 1" class="btn btn-none btn-icon-only-md current-page">
                                                    {{page_index + 1}}
                                                </button>

                                                <button v-if="page_index < page_index_array.length - 2" class="btn btn-none btn-icon-only-md text-nowrap" disabled aria-hidden="true">
                                                    ...
                                                </button>
                                                <button :class="{'current-page': page_index === page_index_array.length - 1}" class="btn btn-none btn-icon-only-md" @click.prevent="moveToPage(page_index_array.length, filtered_user_list)" :key="page_index_array.length">
                                                    {{ page_index_array.length }}
                                                </button>
                                            </div>

                                            <button v-if="page_count > 1" class="btn btn-secondary btn-icon-only-md ms-1" @click.prevent="moveToNextPage(filtered_user_list)" :disabled="page_index === page_count - 1" data-bs-toggle="tooltip" title="Next page">
                                                <img class="icon" src="/img/icons/avid-icons/chevron-right.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>                    
                </div>

            </div>
        </div>

    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import Swal from 'sweetalert2';
    import { useNotifications } from '../../composables/useNotifications';
    import tablePaginationMixin from '../../mixins/table_pagination';
    import permissionsMixin from '../../mixins/permissions';

    export default defineComponent({
        name: 'TeamSettings',
        components: {Swal},
        mixins: [tablePaginationMixin, permissionsMixin],
        setup() {
            const { showNotification } = useNotifications();
            return {
                showNotification
            };
        },
        props: {
            client: {
                type: Object,
                required: true
            },
            user: {
                type: Object,
                required: true
            },
            connections: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                filtered_user_list: [],
                list_shown:[],
                if_show_org_column: false,

                search_key: '',
                sort_key: null,
                sort_order: 'asc',

                filtered_agency_list: [],
                agency_list_shown: [],
                agency_search_key: '',
                agency_sort_key: null,
                agency_sort_order: 'asc',
                agency_num_per_page: 10,
                agency_num_per_page_options: [5,10,15,20,25,30,50,100],
                agency_page_index: 0,
                agency_page_index_array: [],
                agency_page_count: 0,
                agency_item_interval: 0,
                editing_agency: false,
                agency_form: {
                    name: '',
                    email: '',
                    phone: ''
                }
            };
        },
        beforeMount() {
            //If it is open arms
            if (this.client.id === 92) {
                this.filtered_user_list = [...this.client.users].filter(user => this.isAllowedEmailDomain(user.email));
            } else {
                this.filtered_user_list = [...this.client.users];
            }
            this.getUserOrgList();
            this.reloadPagination(this.filtered_user_list);

            // Initialize agency data
            //If it is open arms
            if (this.client.id === 92) {
                this.filtered_agency_list = [...this.client.agencies].filter(agency => this.isAllowedAgency(agency.id));
            } else {
                this.filtered_agency_list = [...(this.client.agencies || [])];
            }
            this.reloadAgencyPagination(this.filtered_agency_list);
        },
        mounted() {
            this.initializeTooltips();
            
        },
        updated() {
            this.$nextTick(() => {
                this.initializeTooltips();
            });
        },
        computed: {
            // Check if an agency has active subscriptions paid by them
            agencyHasActiveSubscriptions() {
                return (agency) => {
                    if (!this.client.subscriptions || !Array.isArray(this.client.subscriptions)) {
                        return false;
                    }
                    
                    return this.client.subscriptions.some(subscription => 
                        subscription.paid_by_id === agency.id && 
                        subscription.paid_by_type === 'App\\Models\\Agency'
                    );
                };
            },
            // Check if a user has active connections (updated_by them)
            userHasActiveConnections() {
                return (user) => {
                    if (!this.connections || !Array.isArray(this.connections)) {
                        return false;
                    }
                    
                    return this.connections.some(connection => 
                        connection.updated_by === user.id
                    );
                };
            },
            // Get active connections for a specific user
            getUserActiveConnections() {
                return (user) => {
                    if (!this.connections || !Array.isArray(this.connections)) {
                        return [];
                    }
                    
                    return this.connections.filter(connection => 
                        connection.updated_by === user.id
                    );
                };
            }
        },
        methods: {
            initializeTooltips() {
                // Destroy existing tooltips first
                const existingTooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                existingTooltips.forEach(el => {
                    const tooltip = window.bootstrap.Tooltip.getInstance(el);
                    if (tooltip) {
                        tooltip.dispose();
                    }
                });

                // Initialize new tooltips
                const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new window.bootstrap.Tooltip(tooltipTriggerEl));

                tooltipTriggerList.forEach((trigger, index) => {
                    trigger.addEventListener('click', () => {
                        tooltipList[index].hide();
                    });
                    trigger.addEventListener('mouseleave', () => {
                        tooltipList[index].hide();
                    });
                });
            },
            isAllowedEmailDomain(email) {
                if( this.user.user_type == 'admin') {
                    return true;
                }
                const userDomain = this.user.email.split('@')[1];
                const emailDomain = email.split('@')[1];
                return emailDomain === userDomain || emailDomain === 'avidai.com';
            },
            isAllowedAgency(agency_id) {
                if( this.user.user_type == 'admin') {
                    return true;
                }
                const userAgency = this.user.agency_id;
                return agency_id === userAgency;
            },
            getUserOrgList(){
                const org_list = [];
                this.filtered_user_list.forEach((user)=>{
                    if (!org_list.includes(user.organization))
                        org_list.push(user.organization);
                });
                if (org_list.length > 1){
                    this.if_show_org_column = true;
                } else{
                    this.if_show_org_column = false;
                }
            },
            showConnectionWarning(user) {
                const activeConnections = this.getUserActiveConnections(user);
                const integrationNames = activeConnections.map(conn => conn.integration?.display_name || conn.integration?.name || 'Unknown Integration');
                
                Swal.fire({
                    title: 'Confirm Team Member Removal',
                    html: `This user is responsible for the following integrations:<br><br><strong>${integrationNames.join('<br>')}</strong><br><br>These will need to be reconnected after removing them. Are you sure you want to continue?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, remove them',
                    cancelButtonText: 'Cancel',
                    customClass: {
                        popup: 'swal-warning'
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.proceedWithUserRemoval(user);
                    }
                });
            },
            proceedWithUserRemoval(user) {
                // Find the user index in the current page
                const userIndex = this.list_shown.findIndex(u => u.id === user.id);
                this.performUserRemoval(user, userIndex);
            },
            async disableUserTwoFactor(u, index) {
                try {
                    await window.axios.post(`/admin/users/${u.id}/disable-two-factor`);
                    u.two_factor_enabled = false;
                    this.showNotification({
                        text: `Two-factor authentication has been disabled for <strong>${u.name}</strong>.`,
                        type: 'success'
                    });
                } catch (err) {
                    const msg = err.response?.data?.message || 'Failed to disable two-factor authentication.';
                    this.showNotification({ text: msg, type: 'error' });
                }
            },
            deleteTeamUser(user, index){
                // Check if user has active connections first
                if (this.userHasActiveConnections(user)) {
                    this.showConnectionWarning(user);
                    return;
                }
                
                // If no active connections, proceed with normal confirmation
                this.performUserRemoval(user, index);
            },
            performUserRemoval(user, index) {
                Swal.fire({
                  title: "Are you sure you want to remove "+ user.first_name + " " + user.last_name+"?",
                  text: "They will lose access to all dashboards and any communications from Avid.",
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Yes, confirm",
                  customClass: {
                    popup: 'swal-warning'
                  },
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.axios.delete('/api/client/' + this.client.url + '/remove_user/' + user.url)
                        .then(response => {
                            const user_index = this.page_index * this.num_per_page + index
                            this.filtered_user_list.splice(user_index, 1);
                            this.reloadPagination(this.filtered_user_list);
                            this.showNotification({
                                text: '<strong>' + user.first_name + ' ' + user.last_name + '</strong> was successfully removed!'
                            });
                            //If the user removed was themselves, redirect back to the homepage /
                            if(user.id == this.user.id)
                                window.location.href = '/';
                            
                        }).catch(error=> {
                            this.showNotification({
                                text: 'Failed to remove <strong>' + user.first_name + ' ' + user.last_name + '</strong>. Please try again.',
                                type: 'error'
                            });
                        });
                    }
                });
            },
            sortByKey(key){
                this.sort_key = key;
                if (this.sort_key != key){
                    this.sort_order = 'asc'; // reset to ascending sorting order
                } else{
                    this.sort_order = (this.sort_order == 'asc'? 'des':'asc');
                }
                this.sortDataWithLabel();
            },
            sortDataWithLabel(){
                if(this.sort_key === 'access') {
                    // Sort by access level using the same logic as the badges
                    const accessOrder = { 'full': 4, 'view': 3, 'custom': 2, 'none': 1 };
                    
                    if(this.sort_order == 'asc') {
                        this.filtered_user_list.sort((a, b) => {
                            const aLevel = this.determineAccessLevel(a.pivot.access);
                            const bLevel = this.determineAccessLevel(b.pivot.access);
                            return accessOrder[aLevel] - accessOrder[bLevel];
                        });
                    } else {
                        this.filtered_user_list.sort((a, b) => {
                            const aLevel = this.determineAccessLevel(a.pivot.access);
                            const bLevel = this.determineAccessLevel(b.pivot.access);
                            return accessOrder[bLevel] - accessOrder[aLevel];
                        });
                    }
                } else {
                    if(this.sort_order == 'asc')
                        this.filtered_user_list.sort((a, b) => (a[this.sort_key] > b[this.sort_key]) ? 1 : -1);
                    else
                        this.filtered_user_list.sort((a, b) => (a[this.sort_key] < b[this.sort_key]) ? 1 : -1);
                }
                this.reloadPagination(this.filtered_user_list);
            },
            searchUser(){
                let filteredList = this.client.users;

                // First filter by search term if one exists
                if(this.search_key !== "") {
                    filteredList = filteredList.filter(user =>
                        user.name.toLowerCase().includes(this.search_key.toLowerCase())
                    );
                }

                // Then apply domain filter if client_id is 92
                if(this.client.id === 92) {
                    filteredList = filteredList.filter(user => this.isAllowedEmailDomain(user.email));
                }

                this.filtered_user_list = filteredList;
                this.reloadPagination(this.filtered_user_list);
            },
            searchAgency(){
                let filteredList = this.client.agencies || [];

                // Filter by search term if one exists
                if(this.agency_search_key !== "") {
                    filteredList = filteredList.filter(agency =>
                        agency.name.toLowerCase().includes(this.agency_search_key.toLowerCase())
                    );
                }

                //If it is open arms
                if (this.client.id === 92) {
                    filteredList = filteredList.filter(agency => this.isAllowedAgency(this.user.agency_id));
                }

                this.filtered_agency_list = filteredList;
                this.reloadAgencyPagination(this.filtered_agency_list);
            },
            deleteAgency(agency, index){
                Swal.fire({
                    title: "Are you sure you want to remove " + agency.name + "?",
                    text: "This will remove access for all of the users associated with this partner.",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, confirm",
                    customClass: {
                        popup: 'swal-warning'
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        
                        window.axios.delete('/api/client/' + this.client.url + '/remove_agency/' + agency.id)
                        .then(response => {
                            const agency_index = this.agency_page_index * this.agency_num_per_page + index;
                            this.filtered_agency_list.splice(agency_index, 1);
                            this.reloadAgencyPagination(this.filtered_agency_list);

                            //Also remove any users from the array that have the same agency id as the removed agency
                            this.filtered_user_list = this.filtered_user_list.filter(user => user.agency_id !== agency.id);
                            this.reloadPagination(this.filtered_user_list);
                            
                            this.showNotification({
                                text: '<strong>' + agency.name + '</strong> was removed!'
                            });
                        }).catch(error => {
                            let errorMessage = 'Error removing this partner!';
                            if (error.response && error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            }
                            
                            this.showNotification({
                                text: 'Failed to remove <strong>' + agency.name + '</strong>. ' + errorMessage,
                                type: 'error'
                            });
                        });
                    }
                });
            },
            sortAgencyByKey(key){
                this.agency_sort_key = key;
                if (this.agency_sort_key != key){
                    this.agency_sort_order = 'asc'; // reset to ascending sorting order
                } else{
                    this.agency_sort_order = (this.agency_sort_order == 'asc'? 'des':'asc');
                }
                this.sortAgencyDataWithLabel();
            },
            sortAgencyDataWithLabel(){
                if(this.agency_sort_key === 'access') {
                    // Sort by access level using the same logic as the badges
                    const accessOrder = { 'full': 4, 'view': 3, 'custom': 2, 'none': 1 };
                    
                    if(this.agency_sort_order == 'asc') {
                        this.filtered_agency_list.sort((a, b) => {
                            const aLevel = this.determineAccessLevel(a.pivot.access);
                            const bLevel = this.determineAccessLevel(b.pivot.access);
                            return accessOrder[aLevel] - accessOrder[bLevel];
                        });
                    } else {
                        this.filtered_agency_list.sort((a, b) => {
                            const aLevel = this.determineAccessLevel(a.pivot.access);
                            const bLevel = this.determineAccessLevel(b.pivot.access);
                            return accessOrder[bLevel] - accessOrder[aLevel];
                        });
                    }
                } else {
                    if(this.agency_sort_order == 'asc')
                        this.filtered_agency_list.sort((a, b) => (a[this.agency_sort_key] > b[this.agency_sort_key]) ? 1 : -1);
                    else
                        this.filtered_agency_list.sort((a, b) => (a[this.agency_sort_key] < b[this.agency_sort_key]) ? 1 : -1);
                }
                this.reloadAgencyPagination(this.filtered_agency_list);
            },
            reloadAgencyPagination(list){
                this.agency_page_count = Math.ceil(list.length / this.agency_num_per_page);
                this.agency_page_index = 0;
                this.agency_page_index_array = [];
                for (let i = 1; i <= this.agency_page_count; i++) {
                    this.agency_page_index_array.push(i);
                }
                this.moveToAgencyPage(1, list);
            },
            moveToAgencyPage(page, list){
                this.agency_page_index = page - 1;
                const start = this.agency_page_index * this.agency_num_per_page;
                const end = start + this.agency_num_per_page;
                this.agency_list_shown = list.slice(start, end);
                this.agency_item_interval = list.length === 0 ? 0 : start + 1 + '-' + Math.min(end, list.length);
            },
            moveToPrevAgencyPage(list){
                if (this.agency_page_index > 0) {
                    this.moveToAgencyPage(this.agency_page_index, list);
                }
            },
            moveToNextAgencyPage(list){
                if (this.agency_page_index < this.agency_page_count - 1) {
                    this.moveToAgencyPage(this.agency_page_index + 2, list);
                }
            },
            getAccessBadgeClass(access) {
                const accessLevel = this.determineAccessLevel(access);
                switch (accessLevel) {
                    case 'full':
                        return 'bg-green bg-icon-success';
                    case 'view':
                        return 'bg-yellow bg-icon-warning';
                    case 'none':
                        return 'bg-red bg-icon-danger';
                    case 'custom':
                        return 'badge-primary';
                    default:
                        return 'badge-seconary';
                }
            },
            getAccessLevel(access) {
                const accessLevel = this.determineAccessLevel(access);
                switch (accessLevel) {
                    case 'full':
                        return 'Full Access';
                    case 'view':
                        return 'View Only';
                    case 'none':
                        return 'Notifications Only';
                    case 'custom':
                        return 'Custom';
                    default:
                        return 'N/A';
                }
            },
            determineAccessLevel(access) {
                if (!access || typeof access !== 'object') {
                    return 'none';
                }

                // Define the modules to check (same as PermissionTable)
                const modules = [
                    'benchmarks', 'scorecard', 'insights', 'pathways', 
                    'playbooks', 'direct_mail', 'connections', 'settings', 'billing'
                ];

                let allView = true;
                let allEdit = true;
                let allExport = true;
                let allViewOnly = true;
                let allNone = true;

                for (const module of modules) {
                    const perms = access[module] || {};
                    
                    // Check view permissions - only if not disabled
                    if (!this.isPermissionDisabled(module, 'view')) {
                        if (perms.view) {
                            allNone = false;
                        } else {
                            allView = false;
                        }
                    }
                    
                    // Check edit permissions - only if not disabled
                    if (!this.isPermissionDisabled(module, 'edit')) {
                        if (perms.edit) {
                            allViewOnly = false;
                            allNone = false;
                        } else {
                            allEdit = false;
                        }
                    }
                    
                    // Check export permissions - only if not disabled
                    if (!this.isPermissionDisabled(module, 'export')) {
                        if (perms.export) {
                            allViewOnly = false;
                            allNone = false;
                        } else {
                            allExport = false;
                        }
                    }
                }
                
                // Determine access level based on the same logic as PermissionTable
                if (allView && allEdit && allExport) return 'full';
                if (allView && allViewOnly && !allEdit && !allExport) return 'view';
                if (allNone) return 'none';
                return 'custom';
            },
            isPermissionDisabled(page, perm) {
                // Scorecard export is always disabled
                if (page === 'scorecard' && perm === 'export') return true;
                // Benchmarks edit is always disabled
                if (page === 'benchmarks' && perm === 'edit') return true;
                // Settings export is always disabled
                if (page === 'settings' && perm === 'export') return true;
                // Billing export is always disabled
                if (page === 'billing' && perm === 'export') return true;
                return false;
            }
        }
    })
</script>
